import { Component, OnInit } from '@angular/core';
import { PdfHandlerService } from './pdf-handler.service';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.css']
})
export class PdfViewerComponent implements OnInit {
    /*
    @Input() viewData;
    totalPages: number;
    pageNumber: number = 1;
    pdf: any;

    scale: number = 1;
    zoomRange: number = 0.25;

    count: number = 1;
    */

    constructor(private pdfHandlerService: PdfHandlerService) { }

    ngOnInit() {
        //this.setInitialProof();
    }

    /*
    setInitialProof() {
        //this.pdfHandlerService.setPdfDocObjects(this.viewData[0]).then((pdf) => {
        this.pdfHandlerService.setPdfDocObjects(this.viewData).then((pdf) => {
            this.pdf = pdf;
            this.totalPages = this.pdf.pdfInfo.numPages;
            this.generateView(this.pageNumber);
        });
    }

    generateView(pageNumber) {

        this.pdf.getPage(pageNumber).then((page) => {
            //let scale = 1;
            let viewport = page.getViewport(this.scale);
            let textLayerDiv: any = document.getElementById("page_1");
            //let canvas: any = document.getElementById('main-canvas');

            let canvas: any;

            if (this.count == 1) {
                canvas = document.createElement("canvas");
                canvas.setAttribute("id", "canvas" + this.viewData.docId);
                document.getElementById(this.viewData.docId).appendChild(canvas);
                this.count = 2;
            }

            canvas = document.getElementById("canvas" + this.viewData.docId);


            let context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            let renderContext = {
                canvasContext: context,
                viewport: viewport
            };
            page.render(renderContext);
            
        });
    }

    changePagePrevious() {
        this.pageNumber = this.pageNumber - 1;
        if (this.pageNumber == 0) {
            alert("firstPage");
            this.pageNumber = 1;
        }
        else {
            this.generateView(this.pageNumber);
        }
    }

    changePageNext() {
        this.pageNumber = this.pageNumber + 1;

        if (this.pageNumber == this.totalPages) {
            
            this.pageNumber = this.totalPages;
            this.generateView(this.pageNumber);
        }
        else if (this.pageNumber > this.totalPages) {
            alert("LastPage");
            this.pageNumber = this.totalPages;
        }
        else {
            this.generateView(this.pageNumber);
        }
    }
    
    


    onZoomIn() {
        this.scale = this.scale + this.zoomRange;
        this.generateView(this.pageNumber);
    }

    onZoomOut() {
        this.scale = this.scale - this.zoomRange;
        this.generateView(this.pageNumber);
    }

    onZoomFit() {
        this.scale = 1;
        this.generateView(this.pageNumber);
    }
    */
}
